import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgentsService } from '@app/services/agents.service';
import { ChannelsService } from '@app/services/channels.service';
import { SharedService } from '@app/services/shared.service';
import { SharedModalComponent } from '@shared/components/modal/modal.component';
import { AnalyticsService } from '@shared/services/analytics.service';
import { IChannel } from 'libs/shared/src/lib/interfaces';

@Component({
  selector: 'blu-select-agent',
  templateUrl: './select-agent.component.html',
  styleUrls: ['./select-agent.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [SharedModalComponent],
})
export class SelectAgentComponent implements OnInit {
  channel?: IChannel;
  selectedAgentId: string | null | undefined = null;
  loading = true;
  saving = false;

  constructor(
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public agentsService: AgentsService,
    private channelService: ChannelsService,
    public analyticsService: AnalyticsService,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const id = this.route.snapshot.paramMap.get('id');
      if (!id) return;

      await Promise.all([this.getChannel(id), this.agentsService.getAgents()]);
    } finally {
      this.loading = false;
    }
  }

  private async getChannel(id: string): Promise<void> {
    const channel = await this.channelService.getChannel(id);
    if (!channel) return;
    this.channel = channel as IChannel;
    this.selectedAgentId = this.channel.activeAgent;
  }

  selectAgent(agentId: string) {
    if (!this.channel) return;
    if (this.selectedAgentId === agentId) this.selectedAgentId = null;
    else this.selectedAgentId = agentId;
  }

  async save(): Promise<void> {
    if (!this.channel?.uid) return;
    try {
      this.saving = true;
      await this.channelService.updateChannel(this.channel.uid, {
        activeAgent: this.selectedAgentId,
      });
      this.sharedService.closeModal(this.route);
    } finally {
      this.saving = false;
    }
  }
}
